__turbopack_context__.v({
  "className": "heading_f98adb45-module__5fCb0q__className",
  "variable": "heading_f98adb45-module__5fCb0q__variable",
});
